import { useTranslation } from 'react-i18next'

import { Flex, Text } from 'components/uiKit'

import { PvzKeys } from '../../../modules/PvzModule/data'
import { ratingRanges } from './data'

import Star from 'assets/img/lk-section/Employee/star.svg?react'

type RatingBadgeProps = {
  rate: number
  type?: 'text' | 'img'
}

const getKey = (key: string) => `${PvzKeys.pvzPage}.${key}`

export const RatingBadge = ({ rate, type = 'text' }: RatingBadgeProps) => {
  const { t } = useTranslation()

  const ratingColor = (rating: number): string => {
    const range = ratingRanges.find(({ min, max }) => rating >= min && rating <= max)
    return range ? range.color : '#000'
  }

  return (
    <>
      {Boolean(rate) && (
        <Text type="secondary">
          <Flex align="center" gap={4}>
            {type === 'img' ? <Star style={{ fill: ratingColor(rate) }} /> : t(getKey('Рейтинг')) + ':'}{' '}
            <Text style={{ color: ratingColor(rate) }}>{rate}</Text>
          </Flex>
        </Text>
      )}
    </>
  )
}
